export interface PaginationDto {
    total: number
    count: number
    per_page: number
    current_page: number
    total_pages: number
}

export interface Pagination {
    total: number
    count: number
    perPage: number
    currentPage: number
    totalPages: number
}

export const createPagination = (
    params: {
        total: number,
        count: number,
        perPage: number,
        currentPage: number,
        totalPages: number,
    }
): Pagination => ({
    total: params.total,
    count: params.count,
    perPage: params.perPage,
    currentPage: params.currentPage,
    totalPages: params.totalPages,
})

export const paginationFromDto = (dto: PaginationDto): Pagination => (createPagination({
    total: dto.total,
    count: dto.count,
    perPage: dto.per_page,
    currentPage: dto.current_page,
    totalPages: dto.total_pages,
}))

const DEFAULT_PAGINATION: Pagination = {
    total: 0,
    count: 0,
    perPage: 15,
    currentPage: 1,
    totalPages: 1,
}

export const getDefaultPagination = (): Pagination => {
    return { ...DEFAULT_PAGINATION }
}

export const DEFAULT_PER_PAGE = 15